<template>
  <div style="padding-bottom: 10px;box-sizing: border-box;">
    <img src="../../../static/banner.png" alt="" style="width: 100%;" />
    <div @click="saveImg">
      <img
        ref="targetImage"
        :src="imageUrl"
        style="width: 92%;display:block;margin: 0 auto;"
      />
    </div>
    <img
      src="../../../static/text.png"
      alt=""
      style="width: 64%;margin-top: 10px;margin-left: 4%;"
    />
    <div
      style="display: flex; justify-content: space-between;width: 80%;margin: 0 auto;margin-top: 10px;"
    >
      <div :class="['item', index == 0 ? 'active' : '']" @click="select(0)">
        <img src="../../../static/sxlc.png" alt="" />
        <div>授信流程</div>
      </div>
      <div>
        <img
          src="../../../static/right.png"
          alt=""
          style="width: 13px;height: 12px;"
        />
      </div>
      <div :class="['item', index == 1 ? 'active' : '']" @click="select(1)">
        <img src="../../../static/jklc.png" alt="" />
        <div>借款流程</div>
      </div>
      <div>
        <img
          src="../../../static/right.png"
          alt=""
          style="width: 13px;height: 12px;"
        />
      </div>
      <div :class="['item', index == 2 ? 'active' : '']" @click="select(2)">
        <img src="../../../static/hklc.png" alt="" />
        <div>还款流程</div>
      </div>
    </div>
    <div style="margin-top: 20px;min-height: 100vh;">
      <img
        v-if="index == 0"
        src="../../../static/1.png"
        alt=""
        style="width: 92%;display:block;margin: 0 auto;"
      />
      <img
        v-if="index == 1"
        src="../../../static/2.png"
        alt=""
        style="width: 92%;display:block;margin: 0 auto;"
      />
      <img
        v-if="index == 2"
        src="../../../static/3.png"
        alt=""
        style="width: 92%;display:block;margin: 0 auto;"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 0,
      imageUrl: "https://down.baoanlailou.com/file/xdqrcode.png"
    };
  },
  methods: {
    select(i) {
      this.index = i;
    },

    detectMobileOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone必须放在前面，因为它的UA也包含"Android"
      if (/windows phone/i.test(userAgent)) return "Windows Phone";

      if (/android/i.test(userAgent)) return "Android";

      // iOS检测
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        // 检测是否是桌面模式下的Safari
        const isSafari = navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        return isSafari ? "iOS (可能是桌面模式)" : "IOS";
      }

      return "Unknown";
    },
    saveImg() {
      if (this.detectMobileOS() == "IOS") {
        try {
          let obj = window.webkit.messageHandlers["imageClick"].postMessage(
            this.imageUrl
          );
          alert(obj);
        } catch (error) {
          console.error("请求失败:", error);
        }
      } else {
        Android.imageClick(this.imageUrl);
      }
    }
  }
};
</script>
<style scoped>
.item {
  text-align: center;
  opacity: 0.8;
  color: #7c8294;
}
.active {
  opacity: 1;
  color: #000;
  font-weight: bold;
}
.item img {
  width: 28px;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/view/share/share.vue